import type {WeatherState} from './types';

// find detail on the map tile serving in docs/map-tile-hosting.md
export const MAP_DATA_URL = 'https://map-data.nutshell.com/static/base.json';

export const MAPLIBRE_ZOOM_LEVELS = {
    base: 5,
    hover: 8,
    superZoom: 14,
} as const;

export const MAPLIBRE_ZOOM_TRANSITION_MS = 800;

// Same accuracy values as Nut_Geocoder::ACCURACY_* constants, following old
// pattern in jquery of having frontend map
export const LOCATION_ACCURACY = {
    unknown: 0,
    country: 1,
    region: 2,
    subregion: 3,
    city: 4,
    postcode: 5,
    street: 6,
    intersection: 7,
    address: 8,
} as const;

export const WEATHER_ILLUSTRATION_BY_STATE: Record<WeatherState, string> = {
    storm: 'weather-conditions/cloud-bolt-duotone-regular-full',
    rain: 'weather-conditions/cloud-rain-duotone-regular-full',
    sleet: 'weather-conditions/cloud-hail-mixed-duotone-regular-full',
    snow: 'weather-conditions/snowflake-duotone-regular-full',
    fog: 'weather-conditions/cloud-fog-duotone-regular-full',
    wind: 'weather-conditions/wind-duotone-regular-full',
    'clear-day': 'weather-conditions/sun-bright-duotone-regular-full',
    cloudy: 'weather-conditions/cloud-duotone-regular-full',
    'cloudy-night': 'weather-conditions/cloud-moon-duotone-regular-full',
    'cloudy-day': 'weather-conditions/cloud-sun-duotone-regular-full',
    'clear-night': 'weather-conditions/moon-duotone-regular-full',
};
